
    var mustache = require('mustache');
    module.exports = function (view, partials) {
      partials = partials || {};
      var src = "<html>\n<head><title>Backup Authentication Codes</title>\n</head>\n<body>\n{{#recoveryCodes}}\n    <p>{{code}}</p>\n{{/recoveryCodes}}\n</body>\n</html>\n"
      return mustache.render(src, view, partials);
    };
  